<template>
  <div class="settlement-detail-cell">
    <div class="header f-12 c-6 flex flex-ac">
      <span
        >订单编号：
        <span class="link" @click="goOrder(data.bizOrderNo)">{{ data.bizOrderNo }}</span>
      </span>
      <i class="el-icon-s-comment c-hover f-16 m-l10" @click="showIM(data.buyerId)"></i>
    </div>
    <div class="thead">
      <div class="col-1 text-head" style="justify-content: flex-start;">商品</div>
      <div class="col-2 text-head">商品属性</div>
      <div class="col-3 text-head">预提数量/重量</div>
      <div class="col-4 text-head">实提数量/重量</div>
      <div class="col-5 text-head">商品单价</div>
      <div class="col-6 text-head">结算单价</div>
      <div class="col-7 text-head">结算数量</div>
      <div class="col-8 text-head">结算重量</div>
      <div class="col-9 text-head">结算金额</div>
    </div>
    <div class="tbody lh-20" v-for="(item, index) in data.list" :key="index">
      <div class="m-t10 m-l10 f-12 c-6">
        <span>提单编号：{{ item.ladingNo }}</span>
        <span class="m-l20">收货时间：{{ item.receivedTime | parseTime }}</span>
      </div>
      <div class="row">
        <div class="col-1 p-10 flex-h-ac">
          <i
            v-if="item.changeFlag"
            class="el-icon-warning-outline f-16 c-6 m-r10"
            @click="$emit('change-record', item)"
          ></i>
          <div>
            <p class="f-14 c-3">{{ item.itemTitle }}</p>
            <p class="f-12 c-9 m-t10">商品编号：{{ item.itemSkuId || item.itemId }}</p>
            <p v-if="item.supplierName" class="f-12 c-9">{{ item.supplierName }}</p>
          </div>
        </div>
        <div class="col-2 text-attr">
          <p v-if="item.measureType">计量方式：{{ item.measureType }}</p>
          <p v-if="item.chargeUnit">计价单位：{{ item.chargeUnit }}</p>
          <p v-if="item.qualityGrade">质量等级：{{ item.qualityGrade }}</p>
          <p v-if="item.tolerance">公差：{{ item.tolerance }}</p>
          <p v-if="item.bundleNo">捆包号：{{ item.bundleNo }}</p>
          <p v-if="item.perItemWeight">单件重：{{ item | formatPerItemWeight }}</p>
          <p v-if="item.warehouseName">仓库名：{{ item.warehouseName }}</p>
        </div>
        <div class="col-3">{{ item | formatAccruedNumAndWeight }}</div>
        <div class="col-4">{{ item | formatActualNumAndWeight }}</div>
        <div class="col-5">
          ¥{{ item.itemPerAmount | formatMoneyCent | formatPermil }}/{{ item.chargeUnit }}
        </div>
        <div class="col-6">
          <el-input
            :value="item.$settlePerAmount"
            :disabled="data.$disabled"
            @blur="handleInputBlur('settlePerAmount', index)"
            @focus="handleInputFocus('settlePerAmount', index)"
            @input="val => handleInputChange('settlePerAmount', index, val)"
          ></el-input>
        </div>
        <div class="col-7">
          <div v-if="status === 1 && data.$disabled">
            <span class="c-3">{{ item.$settleQuantity }}</span>
            <el-popover v-if="item.tpActualQuantity" placement="right" trigger="hover">
              <img
                slot="reference"
                class="info-warning"
                :src="require('@/assets/icons/info_warning.svg')"
              />
              <span class="f-12 c-6">
                TP实提数量为
                <span class="f-12" style="color:#D0111A;"> {{ item.tpActualQuantity }} 件</span>
              </span>
            </el-popover>
          </div>
          <el-input
            v-else
            :value="item.$settleQuantity"
            :disabled="data.$disabled"
            @blur="handleInputBlur('settleQuantity', index)"
            @focus="handleInputFocus('settleQuantity', index)"
            @input="val => handleInputChange('settleQuantity', index, val)"
          ></el-input>
        </div>
        <div class="col-8">
          <div v-if="status === 1 && data.$disabled">
            <span class="c-3">{{ item.$settleWeight }}</span>
            <el-popover
              v-if="item.tpActualWeight && Number(item.tpActualWeight) !== 0"
              placement="right"
              trigger="hover"
            >
              <img
                slot="reference"
                class="info-warning"
                :src="require('@/assets/icons/info_warning.svg')"
              />
              <span class="f-12 c-6">
                TP实提重量为
                <span class="f-12" style="color:#D0111A;">
                  {{ item.tpActualWeight | formatWeightWithUnit }}
                </span>
              </span>
            </el-popover>
          </div>
          <el-input
            v-else
            :value="item.$settleWeight"
            :disabled="data.$disabled"
            @blur="handleInputBlur('settleWeight', index)"
            @focus="handleInputFocus('settleWeight', index)"
            @input="val => handleInputChange('settleWeight', index, val)"
          ></el-input>
        </div>
        <div class="col-9">
          <el-input
            :value="item.$settleAmount"
            :disabled="data.$disabled"
            @blur="handleInputBlur('settleAmount', index)"
            @focus="handleInputFocus('settleAmount', index)"
            @input="val => handleInputChange('settleAmount', index, val)"
          ></el-input>
        </div>
      </div>
    </div>
    <div class="tfoot">
      <div>
        订单结算小计：
        <span class="text-blod">{{ data.$totalQuantity ? data.$totalQuantity : '--' }}</span
        >件， <span class="text-blod">{{ data.$totalWeight ? data.$totalWeight : '--' }}</span
        >吨
        <span class="m-l10"
          >¥<span class="text-blod">{{ data.$totalAmount | formatTotalAmount }}</span></span
        >
      </div>
      <el-button
        v-if="data.$skuCanModify"
        size="mini"
        type="primary"
        class="m-l20"
        @click="handleModifyInfo"
        >{{ data.$disabled ? '修改结算信息' : '确认结算信息' }}</el-button
      >
    </div>
  </div>
</template>

<script>
import NP from 'number-precision'
import { calculateWithUnit } from '@/common/utils/calculate.js'

const REG_AMOUNT = /^[0-9]+([.]{1}[0-9]{0,2}){0,1}$/
const REG_QUANTITY = /^[0-9]*[1-9][0-9]*$/
const REG_WEIGHT = /(^[1-9]\d{0,7}\.\d{0,6})|(^[1-9]\d{0,7})|(^0\.\d{0,6})|(^0)/

const REGS = {
  ['settlePerAmount']: REG_AMOUNT,
  ['settleAmount']: REG_AMOUNT,
  ['settleQuantity']: REG_QUANTITY,
  ['settleWeight']: REG_WEIGHT
}

export default {
  name: 'ApplyDetailCell',
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    status: [String, Number]
  },
  watch: {
    data: {
      handler: 'calculateTotal',
      immediate: true
    }
  },
  filters: {
    formatPerItemWeight(data) {
      if (data.chargeUnit === '千克') {
        return `${NP.divide(data.perItemWeight, 10)}千克`
      } else {
        return `${NP.divide(data.perItemWeight, 10000)}吨`
      }
    },
    formatAccruedNumAndWeight(data) {
      return `${data.accruedQuantity}件/${NP.divide(data.accruedWeight, 10000)}吨`
    },
    formatActualNumAndWeight(data) {
      return `${data.actualQuantity}件/${NP.divide(data.actualWeight, 10000)}吨`
    },
    formatTotalAmount(amount) {
      if (typeof amount === 'string') {
        amount = parseFloat(amount)
        if (isNaN(amount)) {
          return '--'
        }
      } else if (typeof amount !== 'number') {
        return '--'
      }
      let parts = amount.toString().split('.')
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      return parts.join('.')
    }
  },
  methods: {
    handleInputFocus(type, index) {
      const obj = this.data.list[index]
      const prop = `$${type}`
      if (type === 'settlePerAmount') {
        //结算单价
        obj[prop] = obj[prop].replace('¥', '').replace(`/${obj.chargeUnit}`, '')
      } else if (type === 'settleQuantity') {
        //结算数量
        obj[prop] = obj[prop].replace('件', '')
      } else if (type === 'settleWeight') {
        //结算重量
        obj[prop] = obj[prop].replace('吨', '')
      } else {
        //结算金额
        obj[prop] = obj[prop].replace('¥', '')
      }
    },
    handleInputBlur(type, index) {
      const obj = this.data.list[index]
      const prop = `$${type}`
      const propCopy = `${type}Copy`
      if (obj[prop]) {
        if (type === 'settlePerAmount') {
          //结算单价
          obj[prop] = `¥${obj[prop]}/${obj.chargeUnit}`
        } else if (type === 'settleQuantity') {
          //结算数量
          obj[prop] = `${obj[prop]}件`
        } else if (type === 'settleWeight') {
          //结算重量
          obj[prop] = `${obj[prop]}吨`
        } else {
          //结算金额
          obj[prop] = `¥${obj[prop]}`
        }
        obj[propCopy] = obj[prop]
      } else {
        obj[prop] = obj[propCopy]
      }
      if (type !== 'settleAmount') {
        this.calculateSettleAmount(index)
      } else {
        this.calculateTotal()
      }
    },
    handleInputChange(type, index, val) {
      const obj = this.data.list[index]
      const prop = `$${type}`
      const reg = REGS[type]
      if (val) {
        const match = val.match(reg)
        if (match) {
          if (type === 'settleQuantity') {
            if (match[0] > 9999) {
              obj[prop] = 9999
            } else {
              obj[prop] = match[0]
            }
          } else {
            obj[prop] = match[0]
          }
        }
      } else {
        obj[prop] = ''
      }
      if (type !== 'settleAmount') {
        this.calculateSettleAmount(index)
      } else {
        this.calculateTotal()
      }
    },
    calculateSettleAmount(index) {
      //计算结算金额
      const obj = this.data.list[index]
      if (obj.$settlePerAmount && obj.$settleQuantity && obj.$settleWeight) {
        let settlePerAmount = obj.$settlePerAmount
          .replace('¥', '')
          .replace(`/${obj.chargeUnit}`, '')
        let settleQuantity = obj.$settleQuantity.replace('件', '')
        let settleWeight = obj.$settleWeight.replace('吨', '')
        let settleAmount = calculateWithUnit(
          obj.chargeUnit,
          settleQuantity,
          settleWeight,
          NP.times(settlePerAmount, 100)
        )
        settleAmount = Math.round(settleAmount)
        obj.$settleAmount = `¥${NP.divide(settleAmount, 100)}`
      } else {
        obj.$settleAmount = 0
      }
      this.calculateTotal()
    },
    calculateTotal() {
      //计算结算小计
      let totalQuantity = 0
      let totalWeight = 0
      let totalAmount = 0
      this.data.list.forEach(ele => {
        if (ele.$settleQuantity) {
          totalQuantity = NP.plus(ele.$settleQuantity.replace('件', ''), totalQuantity)
        }
        if (ele.$settleWeight) {
          totalWeight = NP.plus(ele.$settleWeight.replace('吨', ''), totalWeight)
        }
        if (ele.$settleAmount) {
          totalAmount = NP.plus(ele.$settleAmount.replace('¥', ''), totalAmount)
        }
      })
      this.data.$totalQuantity = totalQuantity
      this.data.$totalWeight = totalWeight
      this.data.$totalAmount = totalAmount
      this.$emit('calculate')
    },
    handleModifyInfo() {
      if (!this.data.$disabled) {
        //检查有没有修改
        const modifyArrays = this.getModifySku()
        if (modifyArrays.length > 0) {
          this.modifySku(modifyArrays)
        } else {
          this.data.$disabled = !this.data.$disabled
        }
      } else {
        this.data.$disabled = !this.data.$disabled
      }
    },
    async modifySku(modifyArrays) {
      const request = { settleOrderId: this.$route.params.id }
      const settleOrderItemSaveList = []
      modifyArrays.forEach(ele => {
        let settlePerAmount = ele.$settlePerAmount
          .replace('¥', '')
          .replace(`/${ele.chargeUnit}`, '')
        let settleQuantity = ele.$settleQuantity.replace('件', '')
        let settleWeight = ele.$settleWeight.replace('吨', '')
        let settleAmount = ele.$settleAmount.replace('¥', '')
        let obj = {}
        obj.id = ele.id
        obj.settlePerAmount = NP.times(settlePerAmount, 100)
        obj.settleQuantity = Number(settleQuantity)
        obj.settleWeight = NP.times(settleWeight, 10000)
        obj.settleAmount = NP.times(settleAmount, 100)
        settleOrderItemSaveList.push(obj)
      })
      request.settleOrderItemSaveList = settleOrderItemSaveList
      const { success, data } = await this.$post('settle.seller.saveSettleOrderItems', { request })
      if (success && data) {
        const { value } = data[0]
        if (value) {
          this.data.$disabled = !this.data.$disabled
          this.$message.success('修改成功')
          this.$emit('refresh')
        } else {
          this.$message.error('修改失败')
        }
      }
    },
    getModifySku() {
      const modifyArrays = this.data.list.filter(ele => {
        let settlePerAmount = ele.$settlePerAmount
          .replace('¥', '')
          .replace(`/${ele.chargeUnit}`, '')
        let settleQuantity = ele.$settleQuantity.replace('件', '')
        let settleWeight = ele.$settleWeight.replace('吨', '')
        let settleAmount = ele.$settleAmount.replace('¥', '')

        return (
          NP.times(settlePerAmount, 100) !== ele.settlePerAmount ||
          Number(settleQuantity) !== ele.settleQuantity ||
          NP.times(settleWeight, 10000) !== NP.times(ele.settleWeight, 1) ||
          NP.times(settleAmount, 100) !== ele.settleAmount
        )
      })
      return modifyArrays
    },
    goOrder(orderId) {
      this.$router.push({ name: 'orderDetail', params: { id: orderId } })
    },
    showIM(id) {
      const obj = id ? { sessionId: id } : null
      window.IM && window.IM.show(obj)
    }
  }
}
</script>

<style lang="less" scoped>
.settlement-detail-cell {
  border: 1px solid #f0f0f0;
  margin-top: 20px;
  .header {
    height: 50px;
    line-height: 50px;
    padding: 0 10px;
    background: #f8f8f8;
  }
  .link {
    border-bottom: 1px solid #666;
    cursor: pointer;
  }
  .thead {
    height: 41px;
    line-height: 41px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: 1px solid #f0f0f0;
  }
  .tbody {
    box-sizing: border-box;
  }
  .row {
    display: flex;
    border-bottom: 1px solid #f0f0f0;
  }
  .base-col {
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    padding: 10px;
    font-size: 14px;
    color: #666;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    word-break: break-all;
  }
  .col-1 {
    .base-col;
    width: 15%;
  }
  .col-2 {
    .base-col;
    flex-direction: column;
    align-items: flex-start;
    width: 10%;
  }
  .col-3 {
    .base-col;
    width: 10%;
  }
  .col-4 {
    .base-col;
    width: 10%;
  }
  .col-5 {
    .base-col;
    width: 10%;
  }
  .col-6 {
    .base-col;
    width: 11.25%;
  }
  .col-7 {
    .base-col;
    width: 11.25%;
  }
  .col-8 {
    .base-col;
    width: 11.25%;
  }
  .col-9 {
    .base-col;
    width: 11.25%;
  }
  .tfoot {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    height: 50px;
    padding: 0 20px;
    background: #f8f8f8;
    font-size: 14px;
    font-weight: 500;
    color: #333333;
  }
  .text-blod {
    font-size: 20px;
    color: #f0242e;
  }
  .text-head {
    font-size: 12px;
    color: #999;
  }
  .text-attr {
    font-size: 12px;
    color: #666;
  }
  .info-warning {
    width: 16px;
    height: 16px;
    margin-left: 5px;
    vertical-align: middle;
  }
}
</style>
